import { BlockedCustomerHistory } from 'types';

import { createCrudApi } from './crud.api';

export const blockedCustomersHistoryApi = createCrudApi<BlockedCustomerHistory>(
  '/blocked-customers-history',
);
